const formModal = document.querySelector('.js-form-modal');

const initFormModal = () => {
  if (!formModal) {
    return;
  }
};

export {initFormModal};
